// /CoreWrapper/CustomWrapper.js
import { CoreBase } from './CoreBase'
import { composeCores } from './cores/composeCores'
import { coreBackgroundColorOrGradient } from './cores/coreBackgroundColorOrGradient'
import { coreBorderColorOrGradient } from './cores/coreBorderColorOrGradient'
import { coreColor } from './cores/coreColor'
import { coreGlow } from './cores/coreGlow'
import { coreOrbit } from './cores/coreOrbit'

const CustomWrapper = composeCores(CoreBase, [
	coreColor,
	coreBackgroundColorOrGradient,
	coreBorderColorOrGradient,
	coreOrbit,
	coreGlow
])

export default CustomWrapper
